import { render, staticRenderFns } from "./ViqReportExecSummary.vue?vue&type=template&id=95dc75a2&scoped=true"
import script from "./ViqReportExecSummary.vue?vue&type=script&lang=js"
export * from "./ViqReportExecSummary.vue?vue&type=script&lang=js"
import style0 from "./ViqReportExecSummary.vue?vue&type=style&index=0&id=95dc75a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dc75a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95dc75a2')) {
      api.createRecord('95dc75a2', component.options)
    } else {
      api.reload('95dc75a2', component.options)
    }
    module.hot.accept("./ViqReportExecSummary.vue?vue&type=template&id=95dc75a2&scoped=true", function () {
      api.rerender('95dc75a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqReportExecSummary.vue"
export default component.exports